import styled from 'styled-components';

export const ColumnControlWrapper = styled.div`
    cursor: default;
    position: absolute;
    display: flex;
    justify-content: space-between;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0 2px 4px 0 rgba(28,28,28,0.2);
    color: white;
    top: 0;
    width: 58px;
    height: 26px;
    right: -64px;
    z-index: 2;
    padding: 2px;
    outline: none;
`;

export const IconSpan = styled.span`
    padding: 5px;
`;

export const Icon = styled.i`
    width: 16px;
    height: 16px;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.primary300};
    cursor: pointer;

    :hover {
        color: ${(props) => (props.delete ? props.theme.colors.danger300 : 'black')};
    }
`;

export const IconSpanLeft = styled(IconSpan)`
    left: 2px;
`;

export const IconSpanRight = styled(IconSpan)`
    left: 20px;
`;

export const DropZoneWrapper = styled.div`
    height: ${(props) => (props.isOverColumnItem ? '100px' : '0px')};
    opacity: ${(props) => (props.isOverColumnItem ? '1' : '0')};
    transition: height 0.625s;
    -webkit-transition: height 0.625s;
    margin: 0;
`;

export const DropZoneText = styled.span`
    font-size: 13px;
    color: 'black';
    font-weight: bold;
    background: white;
    width: 120px;
    height: 20px;
    top: calc(50% - 10px);
    left: calc(50% - 60px);
    text-align: center;
    position: absolute;

`;

export const OverrideDropZone = styled.div`
    position: absolute;
    width: 100%;
    height: calc(100% - 188px);
    margin: 0;
    background: #e56969;
    opacity: ${(props) => (props.isOverCurrent ? 1 : 0.9)};
    z-index: 1;
`;

export const OverrideDropZoneText = styled(DropZoneText)`
    line-height: calc(100px - 18px);
    color: white;
`;

export const DragIcon = styled.i`
    transform: rotate(315deg);
    font-size: 17px;
    padding: 6px 5px 5px 6px;
    color: ${({ theme }) => theme.colors.primary300};

    :hover {
        color: white;
    }
`;
